import { useEffect, useState } from "react";
import { Globe, ChevronDown } from "lucide-react";
import { safeGet } from "@/lib/api";
import { useShop } from "@/lib/shop";

// Lets visitors override the detected country (travel, VPN). Prices and checkout follow the choice.
export const CountrySelector = () => {
  const { country, changeCountry } = useShop();
  const [countries, setCountries] = useState([]);
  useEffect(() => {
    safeGet("/countries", null).then((d) => setCountries(Array.isArray(d?.countries) ? d.countries : []));
  }, []);
  if (!countries.length) return null;
  const value = countries.some((c) => c.code === country) ? country : "CH";
  return (
    <div className="mt-8 max-w-xs" data-testid="country-selector">
      <label htmlFor="country-select" className="eyebrow mb-3 block">Country / Currency</label>
      <div className="relative">
        <Globe size={16} className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400" />
        <select id="country-select" data-testid="country-select" value={value} onChange={(e) => changeCountry(e.target.value)}
          className="w-full appearance-none rounded-[2px] border border-line bg-[#0b0b0b] py-3 pl-9 pr-9 text-sm text-white transition-colors hover:border-zinc-500 focus:border-cta focus:outline-none">
          {countries.map((c) => <option key={c.code} value={c.code}>{c.name} ({c.currency})</option>)}
        </select>
        <ChevronDown size={16} className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-zinc-400" />
      </div>
    </div>
  );
};
